import { render, staticRenderFns } from "./columns-display.vue?vue&type=template&id=26a5c486&"
import script from "./columns-display.vue?vue&type=script&lang=js&"
export * from "./columns-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports